import { ToteItem } from "src/types/toteTypes";

const SUPPORTED_CONSUMER_TYPES = [
  "UNSELLABLE_REMOVAL",
  "UNSELLABLE_REMOVAL_NON_FC",
  "NON_FC_UNSELLABLE_REMOVAL",
  "CANDYCANE",
];

/** Whether a tote item can be moved or reported missing. */
export function isSupportedToteItem(item: ToteItem): boolean {
  return (
    SUPPORTED_CONSUMER_TYPES.includes(item.consumerType) ||
    (item.consumerType === "CUSTOMER_SHIPMENT" &&
      item.processingAttribute?.isVRET === true &&
      item.processingAttribute?.vretStatus !== "INCOMPLETE")
  );
}

/** Instruction shown on a tote item that cannot be processed. */
export function getUnsupportedToteItemMessage(item: ToteItem): string {
  switch (item.processingAttribute?.vretStatus) {
    case "INCOMPLETE":
      return "Item missing shipment details, leave in tote and move tote to problem solve area.";
    case "NON_REGULATED":
      return "Unable to process this removals item because it is not REGULATED. If physically present, place it back in the tote and return the tote to the vendor returns department.";
    default:
      return "We cannot update this item, because it is not marked as unsellable. If physically present, place it back in the tote and process the remaining items. When time permits, return the tote and item to the Gate Keeper.";
  }
}
